import { createRouter, createWebHashHistory } from "vue-router";
import main from "../views/main.vue";
import { ElNotification } from "element-plus";

const routes = [
	{
		path: "/",
		name: "main",
		component: main,
		children: [
			{
				path: "/",
				name: "home",
				component: () => import("../views/home/home.vue"),
			},
			{
				path: "/browse",
				name: "browse",
				component: () => import("../views/deploy/browse.vue"),
			},
			{
				path: "/config",
				name: "config",
				component: () => import("../views/deploy/config.vue"),
			},
			{
				path: "/deploy",
				name: "deploy",
				component: () => import("../views/deploy/deploy.vue"),
			},
			{
				path: "/approve",
				name: "approve",
				component: () => import("../views/deploy/approve.vue"),
			},
			{
				path: "/rollback",
				name: "rollback",
				component: () => import("../views/deploy/rollback.vue"),
			},
			{
				path: "/count",
				name: "count",
				component: () => import("../views/deploy/count.vue"),
			},
			{
				path: "/log",
				name: "log",
				component: () => import("../views/deploy/log.vue"),
			},
			{
				path: "/right",
				name: "right",
				component: () => import("../views/deploy/right.vue"),
			},
			{
				path: "/kjrk",
				name: "kjrk",
				component: () => import("../views/pzx/kjrk.vue"),
			},
			{
				path: "/qxbmlb",
				name: "qxbmlb",
				component: () => import("../views/pzx/qxbmlb.vue"),
			},
			{
				path: "/qxyhlb",
				name: "qxyhlb",
				component: () => import("../views/pzx/qxyhlb.vue"),
			},
		],
	},
	{
		path: "/login",
		name: "login",
		component: () => import("../views/login/login.vue"),
	},
	{
		path: "/404",
		name: "404",
		component: () => import("@/views/noPage/404.vue"),
	},
	{
		path: "/linkLog",
		name: "linkLog",
		component: () => import("@/views/noPage/linkLog.vue"),
	},
	{
		path: "/:catchAll(.*)",
		redirect: "/404",
	},
];

const router = createRouter({
	history: createWebHashHistory(),
	routes,
});

const whiteList = ["login", "linkLog"];
router.beforeEach((to, from, next) => {
	if (localStorage.getItem("token")) {
		next();
	} else {
		if (whiteList.indexOf(to.name) !== -1) {
			next();
		} else {
			ElNotification({
				title: "系统提示",
				message: "未登录，请登录",
				type: "error",
				duration: 3000,
			});
			next({ path: "/login" });
		}
	}
});
export default router;
